var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.items.length > 0)?_c('div',{staticClass:"ve-grid"},[_vm._l((_vm.items),function(item,index){return _c('card',{key:index,attrs:{"title":item.title,"url":item.url,"imageUrl":item.imageUrl}})}),_vm._v(" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }